import { useState, useEffect } from 'react';
import { colorStyle } from './farbschema.js';
import FindGuest from './find_guest.js';
import  {Stack, Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel,
  Button, TextField, Select, MenuItem  } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import moment from 'moment';
import 'moment/dist/locale/de';

const EditBed = ({open, close, pos, getInfoBetten, setResChange, bedInfo, getInfoGast, getGastInfo, updateGastValue, countries, alterskats, roomInfo, loadGast}) => {

  const [visible, setVisible] = useState(true);
  const [priceStr, setPriceStr] = useState('');
  const [findguest, setFindguest] = useState(false);

  useEffect(() => { 
    if (open) { 
      setVisible(true); 
      if (bed.preis) {
        setPriceStr(bed.preis.toFixed(2));
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }}, [open]);


  const doClose = () => {
    setVisible(false);
    setTimeout(close, 50);
  }


  if (pos===false) return null;
  const betten = getInfoBetten();
  const bed = betten[pos];

  const zId = bed.id_zimmer;
  let personen = 0;
  let belegung = 0;
  betten.forEach((b, k) => {
    if (b.id_zimmer !== zId) return;
    if (b.geschlecht !== 3) {
      personen++;
    }
    belegung++;
  });

  let preis = 0;
  let bel = 0;
  if (belegung >= roomInfo.find(x=>x.id===zId)?.anzbett) {
    bel = personen;
  }
  const preise = roomInfo?.find(x=>x.id===zId)?.preise;
  if (preise) {
    preis = preise.find(x=>x.belegung===bel && x.id_alterskat===bed.alterskat_id)
  }
  if (preise && !preis) {
    preis = preise.find(x=>x.belegung===0 && x.id_alterskat===bed.alterskat_id)
  }
  if (preise && !preis) {
    preis = preise.find(x=>x.belegung===bel && x.id_alterskat===alterskats[0].id)
  }
  if (preise && !preis) {
    preis = preise.find(x=>x.belegung===0 && x.id_alterskat===alterskats[0].id)
  }
  const bettPreis = preis?preis.preis:0;

  const updateGuest = (field) => (e) => {
    updateGastValue(bed.id_gast, field, e.target.value);
  }

  const gastInfo = (field) => {
    return getGastInfo(bed.id_gast, field);
  }

  const updateBedValue = (field, value) => {
    setResChange(rc=>{
      const betten = [...rc.betten];
      betten[pos][field] = value;
      return ({...rc, betten: betten});
    });
  }

  const updateBed = (field) => (e) => {
    updateBedValue(field, e.target.value);
    if (field==='bett_id') {
      updateBedValue('bezeichnung', bedInfo.find(x=>x.bett_id===e.target.value)?.bezeichnung);
      updateBedValue('buchstabe', bedInfo.find(x=>x.bett_id===e.target.value)?.buchstabe);
    }
  }

  const newGuest = () => {
    const bedinfo = getInfoBetten();
    let newid = bedinfo.reduce((min, item) => item.id_gast < min ? item.id_gast : min, 2147483647) - 1;
    if (newid > 0) newid = -1;
    const guest = getInfoGast(bedinfo[pos].id_gast);
    guest.vorname = '';
    setResChange(rc=>({...rc, gaeste:{...rc.gaeste, [newid]:guest}}));
    updateBedValue('id_gast', newid);
//    updateGastValue(newid, 'vorname', '');
  }
  

  const selGuest = (id) => (ev) => {
    loadGast(id);
    updateBedValue('id_gast', id);
    setFindguest(false);
  }

  const bettenlist = [...bedInfo];
  if (!bettenlist.find(x=>x.bett_id===bed.bett_id)) {
    bettenlist.unshift({bett_id: bed.bett_id, bezeichnung: bed.bezeichnung, buchstabe: bed.buchstabe});
  }
  return (
    <>
      <Dialog open={open} onClose={doClose} TransitionComponent={undefined}>
        <DialogActions style={{position:'absolute', right:0}}>
          <Button label="ra.action.cancel" onClick={doClose}><IconCancel /></Button>
        </DialogActions>
        <DialogTitle sx={{pb:1}}>Edit beds</DialogTitle>
        <DialogContent sx={{pb:1}}>
{findguest && <FindGuest setFindguest={setFindguest} selGuest={selGuest} />}
{visible && <>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <TextField label="First name" value={gastInfo('vorname')} onChange={updateGuest('vorname')} />
            <TextField label="Name" value={gastInfo('name')} onChange={updateGuest('name')} />
            <TextField label="Date of birth" type="date" value={moment(gastInfo('geburtsdatum')+"").format('YYYY-MM-DD')} onChange={updateGuest('geburtsdatum')} />
          </Stack>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Residence</InputLabel>
              <Select label="Residence" value={gastInfo('id_land')} onChange={updateGuest('id_land')}>
    {countries.map((c) => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}  
              </Select>
            </FormControl>
            <TextField label="Passport number" value={gastInfo('pass')} onChange={updateGuest('pass')} />
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Nationality</InputLabel>
              <Select label="Nationality" value={gastInfo('id_passland')} onChange={updateGuest('id_passland')}>
    {countries.map((c) => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}  
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2} sx={{mb:2}}>
            <Button variant="contained" color="primary" onClick={()=>setFindguest(true)}>Lookup Guest</Button>
            <Button variant="contained" color="primary" onClick={newGuest}>New Guest</Button>
            <Button variant="contained" color="primary" onClick={doClose}>Full Guest Edit</Button>
          </Stack>
          <Stack direction="row" spacing={2} sx={{'& > *':{flex:1}, mb:2}}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Gender</InputLabel>
              <Select label="Gender" value={bed.geschlecht} onChange={updateBed('geschlecht')}>
                <MenuItem value={0}>Female</MenuItem>
                <MenuItem value={1}>Male</MenuItem>
                <MenuItem value={2}>Mixed</MenuItem>
                <MenuItem value={3}>Empty</MenuItem>
              </Select>
            </FormControl>
            <FormControl>
              <Select label="Move Bed" value={bed.alterskat_id} onChange={updateBed('alterskat_id')}>
  {alterskats.map((a) => (
                <MenuItem key={a.id} value={a.id}>{a.bezeichnung}</MenuItem>
    ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2} sx={{'& > *':{flex:1}}}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Move Bed</InputLabel>
              <Select label="Move Bed" value={bed.bett_id} onChange={updateBed('bett_id')}>
  {bettenlist.map((b) => (
                <MenuItem key={b.bett_id} value={b.bett_id} style={{display:'grid', gridTemplateColumns: 'auto 10% 50%'}}>
                  <span style={{...colorStyle(b.farbe), padding:'0 0.3em'}}>{b.bezeichnung}{b.buchstabe}</span> 
                  <span></span>
                  <span style={{...colorStyle(b.pkfarbe), padding:'0 0.3em'}}>({b.kurzbez})</span>
                </MenuItem>
    ))}
              </Select>
            </FormControl>
            <Stack direction="row" spacing={2}>
              <Box sx={{pt:'1.3em'}} onClick={() => {updateBedValue('preis', bettPreis); setPriceStr(bettPreis.toFixed(2)) }} className="clickable">{bettPreis}</Box>
              <TextField label="Price" value={priceStr} onChange={(e)=>{ setPriceStr(e.target.value); updateBedValue('preis', parseFloat(e.target.value))}} />
            </Stack>
          </Stack>
  </>}                    
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={doClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditBed;